import { Label as LabelRoot } from 'radix-ui';
import { MdInfoOutline } from 'react-icons/md';
import styled, { css } from 'styled-components';

import {
  BaseAccordion,
  BaseAccordionContent,
  BaseAccordionItem,
  BaseAccordionTrigger,
  BaseCheckbox,
  BaseTooltip,
  FormModal,
} from '@gbs-monorepo-packages/common';
import { colors, fonts, radii, scrollbar } from '@gbs-monorepo-packages/styles';

export const PlanGroupName = styled.p`
  margin-bottom: 0.3rem;
  color: ${colors.textLight};
  font-weight: 400;
  font-size: ${radii.lg};
  font-family: ${fonts.admin};
  text-transform: capitalize;
`;

export const ErrorMessage = styled.p`
  font-size: 0.7rem;
  color: ${colors.red300};
  margin: 15px 0px 15px 0px;
`;

export const SpacedContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

interface ILabelCheckboxProps {
  readonly fontWeight?: string;
  readonly disabled?: boolean;
}

export const LabelCheckBox = styled(LabelRoot.Root)<ILabelCheckboxProps>`
  color: ${colors.labelText};
  font-size: 14px;
  line-height: 1.3;
  user-select: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: ${({ fontWeight }) => fontWeight ?? '400'};
  cursor: pointer;

  ${({ disabled = false }) =>
    disabled &&
    css`
      color: ${colors.gray350};
      cursor: not-allowed;
    `}
`;

export const CustomBaseCheckbox = styled(BaseCheckbox)`
  color: ${colors.blue400};
`;

export const CheckContainer = styled.div`
  align-items: center;
  display: inline-flex;
  height: 100%;
  justify-content: flex-end;
  padding-right: 0.5rem;
`;

export const LabelCheckContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Container = styled.div`
  overflow: hidden;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 0;
  margin-top: 0.5rem;
  ${scrollbar};
`;

export const TableContainer = styled.div`
  display: block;
`;

export const CustomTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const Tbody = styled.tbody`
  border-top: 1px solid ${colors.gray200};
  padding-top: 0.5rem;
  display: block;
`;

export interface ITdProps {
  readonly textAlign?: string;
  readonly width?: string;
}

export const Td = styled.td<ITdProps>`
  text-align: ${({ textAlign }) => textAlign ?? 'left'};
  display: ${({ textAlign }) =>
    textAlign === 'left' ? 'inline-flex' : 'block'};
  align-items: center;
  height: 24px;
  width: ${({ width }) => width ?? 'auto'};
`;

export const TdArrows = styled.td`
  display: inline-block;
  height: 24px;
  text-align: right;
  align-content: center;
`;
export interface IThProps {
  readonly textAlign?: string;
}

export const Th = styled.th<IThProps>`
  font-weight: 400;
  font-size: 11px;
  text-align: ${({ textAlign }) => textAlign ?? 'left'};
  flex-grow: 1;
`;

export const TrSpreadPlan = styled.tr`
  display: grid;
  grid-template-columns: 10% 1fr 15% 15%;
  gap: 8px;
  margin-bottom: 0.5rem;
`;

export const Tr = styled.tr`
  display: grid;
  grid-template-columns: 10% 1fr 15% 15%;
  gap: 8px;
  margin-bottom: 1rem;
`;

export const InfoIcon = styled(MdInfoOutline)`
  cursor: pointer;
  vertical-align: middle;
  margin-left: 5px;
`;

export const CustomBaseTooltip = styled(BaseTooltip)`
  z-index: 10;
`;

export const DividerTitle = styled.p`
  font-weight: bold;
  color: ${colors.textLight};
  padding: 0.5rem auto;
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
`;

interface ITextTitleProps {
  readonly fontWeight?: 'bold' | 'normal';
}

export const TextTitle = styled.p<ITextTitleProps>`
  font-weight: ${({ fontWeight }) => fontWeight ?? 'bold'};
  color: ${colors.textLight};
  padding: 0.5rem auto;
  margin-bottom: 0.5rem;
`;

export const ListContainer = styled.div`
  border-radius: ${radii.md};
  padding: 5px 10px;
  margin-bottom: 1rem;
`;

export const CustomAccordion = styled(BaseAccordion)`
  width: 100%;
  margin: 1rem 0;
`;

export const CustomAccordionItem = styled(BaseAccordionItem)`
  padding: 0.5rem auto;
  border: 1px solid ${colors.gray200};
  border-radius: ${radii.px};
  margin-bottom: 0.5rem;
`;

export const CustomAccordionTrigger = styled(BaseAccordionTrigger)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0.5rem;
  cursor: pointer;
  width: 100%;
  background-color: ${colors.white300};
  border: none;
  font-weight: bold;
  color: ${colors.textLight};
  font-size: 16px;
`;

export const CustomAccordionContent = styled(BaseAccordionContent)`
  padding: 0.5rem 1rem;
`;

export const FormModalWide = styled(FormModal)`
  max-width: 900px;
`;

export const TextContainer = styled.div`
  align-items: center;
  display: flex;
  flex-grow: 1;
  justify-content: center;
  margin-top: 1rem;
`;

export const Text = styled.p`
  color: ${colors.textLight};
  font-size: 1rem;
  font-weight: 400;
`;
